//@ts-ignore
import privacyPolicy from './Privacy.pdf';
//@ts-ignore
import termsandconditions from './TermsAndCondition.pdf';
import RadioComponent from '../../components/nds/radio/radio';
import styles from './PrivacyPolicy.module.scss';

const radioOption = [
    {
        label: 'Yes – I acknowledge and accept',
        value: 'Yes',
    },
    {
        label: 'No – I do not accept',
        value: 'No',
    },
];

const PDFViewer = (props: {
    id: number;
    selectedOption: string | undefined;
    handleRadioChange: (selectedOption: string, index: number) => void;
}) => {
    const { id, selectedOption, handleRadioChange } = props;
    return (
        <div className='nexus-mt-3 nexus-mb-3'>
            {id === 0 ? (
                <>
                    <iframe
                        className={styles['privacy-notice-iframe']}
                        src={privacyPolicy + '#toolbar=0&navpanes=0&view=FitH'}
                    ></iframe>
                    <div className={styles['radio-container']}>
                        <RadioComponent
                            options={radioOption}
                            selectedValue={selectedOption}
                            input={{
                                name: id + `-privacy-policy`,
                                onChange: (selectedOption: string) => {
                                    handleRadioChange(selectedOption, id);
                                },
                            }}
                        />
                    </div>
                </>
            ) : (
                <>
                    <iframe
                        className={styles['privacy-notice-iframe']}
                        src={termsandconditions + '#toolbar=0&navpanes=0&view=FitH'}
                    ></iframe>
                    <div className={styles['radio-container']}>
                        <RadioComponent
                            options={radioOption}
                            selectedValue={selectedOption}
                            input={{
                                name: id + `-privacy-policy`,
                                onChange: (selectedOption: string) => {
                                    handleRadioChange(selectedOption, id);
                                },
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default PDFViewer;
